# Object methods

if typeof Object.isEmpty is 'undefined'
  Object.defineProperty Object, 'isEmpty', value: (object) ->
    false for _ of object
    true

if typeof Object.compact is 'undefined'
  Object.defineProperty Object, 'compact', value: (object) ->
    Object.filter object, (item) => item?

if typeof Object.extract is 'undefined'
  Object.defineProperty Object, 'extract', value: (object, keys) ->
    result = {}
    (result[key] = object[key]; delete object[key]) for key in keys when key of object
    result

if typeof Object.count is 'undefined'
  Object.defineProperty Object, 'count', value: (object, callbackFn = (() => true), initialValue = 0) ->
    Object.sum object, ((value, key, object) => if callbackFn(value, key, object) then 1 else 0), initialValue

if typeof Object.sum is 'undefined'
  Object.defineProperty Object, 'sum', value: (object, callbackFn = ((item) => item), initialValue = 0) ->
    Object.reduce object, ((sum, value, key, object) => sum + callbackFn(value, key, object)), initialValue

if typeof Object.product is 'undefined'
  Object.defineProperty Object, 'product', value: (object, callbackFn = ((item) => item), initialValue = 1) ->
    Object.reduce object, ((product, value, key, object) => product * callbackFn(value, key, object)), initialValue

if typeof Object.min is 'undefined'
  Object.defineProperty Object, 'min', value: (object, callbackFn = ((item) => item), initialValue = Infinity) ->
    Object.reduce object, ((min, value, key, object) => Math.min(min, callbackFn(value, key, object))), initialValue

if typeof Object.max is 'undefined'
  Object.defineProperty Object, 'max', value: (object, callbackFn = ((item) => item), initialValue = -Infinity) ->
    Object.reduce object, ((max, value, key, object) => Math.max(max, callbackFn(value, key, object))), initialValue

if typeof Object.some is 'undefined'
  Object.defineProperty Object, 'some', value: (object, callbackFn, thisArg) ->
    return true for key, value of object when callbackFn.call thisArg, value, key, object
    false

if typeof Object.every is 'undefined'
  Object.defineProperty Object, 'every', value: (object, callbackFn, thisArg) ->
    return false for key, value of object when !callbackFn.call thisArg, value, key, object
    true

if typeof Object.find is 'undefined'
  Object.defineProperty Object, 'find', value: (object, callbackFn, thisArg) ->
    return value for key, value of object when callbackFn.call thisArg, value, key, object
    undefined

if typeof Object.forEach is 'undefined'
  Object.defineProperty Object, 'forEach', value: (object, callbackFn, thisArg) ->
    callbackFn.call thisArg, value, key, object for key, value of object
    undefined

if typeof Object.filter is 'undefined'
  Object.defineProperty Object, 'filter', value: (object, callbackFn, thisArg) ->
    result = {}
    result[key] = value for key, value of object when callbackFn.call thisArg, value, key, object
    result

if typeof Object.filterToArray is 'undefined'
  Object.defineProperty Object, 'filterToArray', value: (object, callbackFn, thisArg) ->
    result = []
    result.push(value) for key, value of object when callbackFn.call thisArg, value, key, object
    result

if typeof Object.reduce is 'undefined'
  Object.defineProperty Object, 'reduce', value: (object, callbackFn, initialValue) ->
    initialValue = callbackFn initialValue, value, key, object for key, value of object
    initialValue

if typeof Object.mapKeys is 'undefined'
  Object.defineProperty Object, 'mapKeys', value: (object, callbackFn, thisArg) ->
    result = {}
    result[callbackFn.call thisArg, value, key, object] = value for key, value of object
    result

if typeof Object.mapValues is 'undefined'
  Object.defineProperty Object, 'mapValues', value: (object, callbackFn, thisArg) ->
    result = {}
    result[key] = callbackFn.call thisArg, value, key, object for key, value of object
    result

if typeof Object.mapEntries is 'undefined'
  Object.defineProperty Object, 'mapEntries', value: (object, callbackFn, thisArg) ->
    result = {}
    Object.assign result, callbackFn.call thisArg, value, key, object for key, value of object
    result

if typeof Object.mapToArray is 'undefined'
  Object.defineProperty Object, 'mapToArray', value: (object, callbackFn, thisArg) ->
    result = []
    result.push(callbackFn.call thisArg, value, key, object) for key, value of object
    result

if typeof Object.flatMap is 'undefined'
  Object.defineProperty Object, 'flatMap', value: (object, callbackFn, thisArg) ->
    result = []
    result = result.concat(callbackFn.call thisArg, value, key, object) for key, value of object
    result

if typeof Object.flat is 'undefined'
  Object.defineProperty Object, 'flat', value: (object, depth = 1) ->
    result = []
    result = result.concat(value) for key, value of object
    result.flat(depth - 1)

if typeof Object.group is 'undefined'
  Object.defineProperty Object, 'group', value: (object, callbackFn, thisArg) ->
    Object.reduce object, ((result, item, oldKey, object) =>
      key = callbackFn.call thisArg, item, oldKey, object
      if key of result then result[key].push(item) else result[key] = [item]
      result), {}

if typeof Object.transpose is 'undefined'
  Object.defineProperty Object, 'transpose', value: (object, callbackFn, thisArg) ->
    Object.reduce object, ((result, array) =>
      array.forEach((item) =>
        key = callbackFn.call thisArg, item
        if key of result then result[key].push(item) else result[key] = [item])
      result), {}

if typeof Object.fill is 'undefined'
  Object.defineProperty Object, 'fill', value: (object, value = undefined, count = 0) ->
    Object.assign object, Array(count - Object.count(object)).fill(value)

if typeof Object.flatValues is 'undefined'
  Object.defineProperty Object, 'flatValues', value: (object, depth = 1) ->
    Object.values(object).flat(depth)

if typeof Object.sortValues is 'undefined'
  Object.defineProperty Object, 'sortValues', value: (object, compareFn = localeCompare) ->
    Object.values(object).sort(compareFn)

if typeof Object.concatValues is 'undefined'
  Object.defineProperty Object, 'concatValues', value: (result, objects...) ->
    for object in objects
      result[key] = (result[key] ? []).concat(value) for key, value of object
    result

if typeof Object.assignValues is 'undefined'
  Object.defineProperty Object, 'assignValues', value: (result, callbackFn, objects...) ->
    for object in objects
      for key, values of object
        if result[key] then result[key][callbackFn(value)] = value for value in values
        else result[key] = values
    result

if typeof Object.camelizeEntries is 'undefined'
  Object.defineProperty Object, 'camelizeEntries', value: (object) ->
    if object instanceof Array then object.map (value) => Object.camelizeEntries(value)
    else if object instanceof Object then Object.mapEntries object, (value, key) => {[key.camelize()]: Object.camelizeEntries(value)}
    else object

if typeof Object.underscoreEntries is 'undefined'
  Object.defineProperty Object, 'underscoreEntries', value: (object) ->
    if object instanceof Array then object.map (value) => Object.underscoreEntries(value)
    else if object instanceof Object then Object.mapEntries object, (value, key) => {[key.underscore()]: Object.underscoreEntries(value)}
    else object
